const LoadingSpinner = () => (
  <>
    {/* Add the keyframe styles dynamically */}
    <style>
      {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
    </style>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div
        className="spinner"
        style={{
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #3498db",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          animation: "spin 0.6s linear infinite", // Apply the animation
        }}
      ></div>
    </div>
  </>
);

export default LoadingSpinner;
